module.exports = __webpack_public_path__ + "static/media/header-bg-shape.c9ec647d.svg";